function ManualSection({ icon, title, children }) {
  return (
    <div className="manual-section">
      {icon && title && (
        <h2 className="manual-section-title">
          <i className={`bi ${icon} me-2`}></i>
          {title}
        </h2>
      )}
      <div className="manual-section-content">
        {children}
      </div>
    </div>
  );
}

export default ManualSection;
